import React from 'react';
import {observer} from "mobx-react";
import {useServices} from "../../../react-hooks/use-services.hook";
import {VideoErrorTitleBox} from "./boxes/video-error-title.box";
import {VideoErrorContainerBox} from "./boxes/video-error-container.box";
import {IVideoPlayerViewModel} from "../../../services/video/models/video-player.view-model.interface";

interface VideoErrorComponentProps {
    videoPlayer: IVideoPlayerViewModel;
}

export const VideoErrorComponent: React.FC<VideoErrorComponentProps> = observer((props) => {
    const services = useServices();

    if(!props.videoPlayer.hasError || props.videoPlayer.watchTimeLimitReached) {
        return null;
    }

    let RetryArrowIcon = services.theme.currentTheme.icons.retryArrowIcon;

    const onClickHandler = async () => {
        await props.videoPlayer.retryPlay();
    }

    return (
        <VideoErrorContainerBox onClick={onClickHandler}>
            <RetryArrowIcon size={7}/>
            <VideoErrorTitleBox>
                {services.translation.translate("VIDEO_SLIDES_ERROR_MAIN_TEXT")}
            </VideoErrorTitleBox>
        </VideoErrorContainerBox>
    )
});